<template>
    <div v-if="visible" class="modal-overlay">
        <div class="modal-content">
            <button class="close-button" @click="closeModal">×</button>

            <div class="error-container">
                <h2 class="modal-title">{{ title }} <span class="loading-icon">⟳</span></h2>
                <p class="modal-message" v-for="m in message" :key="m">{{ m }}</p>


                <div class="modal-actions">
                    <button class="delete-button" @click="handleDelete">
                        <i class="el-icon-delete"></i>
                        Delete Note
                    </button>
                    <button class="close-action" @click="closeModal">
                        <i class="el-icon-close"></i>
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PopupFailedNote',
    props: {
        note: {
            type: Object,
            required: false,
            default: null
        }
    },
    data() {
        return {
            visible: false,
            isDeleting: false,
            errorIcon: require("@/assets/images/home/none_pdf_icon.png")
        }
    },
    computed: {
        title() {
            return 'Note Processing Failed'
        },
        message() {
            return ['Sorry, this note failed to process and its content cannot be accessed.', ' You may delete this note or try again later.']
        }
    },
    methods: {
        openModal() {
            this.visible = true
        },
        closeModal() {
            this.visible = false
        },
        async handleDelete() {
            try {
                // 添加确认对话框
                await this.$confirm(
                    'Are you sure you want to delete this note? This action cannot be undone.',
                    'Warning',
                    {
                        confirmButtonText: 'Delete',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }
                )

                this.isDeleting = true
                const response = await this.$axios.post("/api/deletenote/", {
                    noteid: this.note.noteid,
                    subid: this.$cookies.get("subid"),
                })

                if (response.data.code === 200) {
                    this.$message.success('Note successfully deleted')
                    this.$emit('deleted', this.note)
                    this.closeModal()
                } else {
                    this.$message.error(response.data.messages || 'Failed to delete')
                }
            } catch (error) {
                if (error !== 'cancel') {
                    console.error('Error deleting note:', error)
                    this.$message.error('Delete failed, please try again later')
                }
            } finally {
                this.isDeleting = false
            }
        }
    }
}
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: #fff;
    border-radius: 12px;
    padding: 34px;
    width: 90%;
    max-width: 600px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    animation: fadeIn 0.3s, slideUp 0.3s;
    position: relative;
}

.error-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.modal-title {
    font-size: 20px;
    margin: 0 0 16px 0;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.loading-icon {
    display: inline-block;
    color: #999;
    font-size: 18px;
    animation: rotate 1.5s linear infinite;
    opacity: 0.5;
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.modal-message {
    font-size: 15px;
    line-height: 1.5;
    color: #666;
    max-width: 90%;
}

.modal-actions {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 24px;
    width: 100%;
}

.close-button {
    position: absolute;
    top: 12px;
    right: 12px;
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #999;
    transition: color 0.2s;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
}

.close-button:hover {
    color: #333;
}

.delete-button,
.close-action {
    padding: 8px 16px;
    border-radius: 6px;
    border: none;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
}

.delete-button {
    background-color: #e53935;
    color: white;
}

.delete-button:hover {
    background-color: #c62828;
    transform: translateY(-1px);
}

.close-action {
    background-color: #f5f5f5;
    color: #555;
}

.close-action:hover {
    background-color: #e0e0e0;
    transform: translateY(-1px);
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        transform: translateY(20px);
    }

    to {
        transform: translateY(0);
    }
}
</style>